<template lang="html">
  <div>
    <template v-if="loading">
      <pl-spinner
        style="margin-left: auto; margin-right: auto; margin-top: 200px"
        class="x2 mt10"
      />
    </template>
    <template v-else>
      <div
        v-if="!show_trial_teachers"
        class="row col-xs no-padding no-margin justify-end"
      >
        <pl-button
          v-if="hasAdminAdminPermission"
          class="remove-selected-users pl-ruby"
          style="display: inline-block"
          @click.native="
            selectedUsers.length > 1
              ? removeSelectedUsers()
              : removeUserFromTable(selectedUsers[0])
          "
          :disabled="selectedUsers.length < 1"
        >
          Remove Selected Users
        </pl-button>
      </div>
      <div v-if="!show_trial_teachers && usersToShow.length">
        {{ schoolUsersCountLoaded }} / {{ schoolUsersCount }} Users
      </div>
      <table v-if="usersToShow" class="users-table mt3 w-100">
        <thead>
          <tr class="row">
            <td v-if="hasAdminAdminPermission" class="col-xs-1 b">
              <pl-checkbox
                v-if="!show_trial_teachers"
                v-model="allSelected"
                @change="selectAll"
              />
            </td>
            <td class="col-xs-2 b">Name</td>
            <td class="col-xs-3 b">Email</td>
            <td
              class="col-xs-1 b"
              style="padding-left: 7px"
              v-if="!show_trial_teachers"
            >
              Role
            </td>
            <td class="col-xs-2 b" v-if="!show_trial_teachers">School</td>
            <td class="col-xs-1 b">RTs</td>
            <td
              class="col-xs-1 no-padding b"
              :class="{ 'col-xs-2': show_trial_teachers }"
            >
              Last Active
            </td>
            <td class="col-xs-1 b"></td>
          </tr>
        </thead>
        <tbody
          v-if="usersToShow.length > 0 && !loadingTable"
          id="admin-portal-users-table"
          @scroll="$emit('scroll-on-table')"
          :class="{ trial_teacher_table: show_trial_teachers }"
        >
          <tr class="row" v-for="(user, index) in usersToShow" :key="index">
            <td class="col-xs-1">
              <pl-checkbox
                v-if="!show_trial_teachers && user.id !== getProfile.id"
                :id="user.id"
                v-model="user.selected"
                @change="checkAllSelected"
                class="col-xs-1"
              />
            </td>
            <td class="col-xs-2 flex items-center">
              <div
                @click="openUserDetails(user)"
                class="avatar-circle avatar-size mr2 cursor-pointer"
                :style="{
                  backgroundImage: 'url(' + user.avatar_url + ')',
                  'background-size': 'cover',
                  'background-position': 'center',
                }"
              ></div>
              <span
                class="name-cell cursor-pointer truncate"
                @click="openUserDetails(user)"
                :title="user.name"
              >
                {{ user.name }}
              </span>
            </td>
            <td class="col-xs-3 email-cell" :title="user.email">
              {{ user.email }}
            </td>
            <td class="col-xs-1 no-padding" v-if="!show_trial_teachers">
              <pl-select
                v-if="hasAdminAdminPermission && user.id !== getProfile.id"
                :id="'select_id_' + index"
                :options="roles"
                :selected="user.role"
                :arrow="true"
                :isLoading="user.id === loadingUser"
                :disabled="user.id === loadingUser"
                @change="changeUserRole(user.id, $event)"
                class="no-padding"
                style="text-transform: capitalize"
              >
              </pl-select>
              <span v-else class="ml3">{{ user.role }} </span>
            </td>
            <td class="col-xs-2" v-if="!show_trial_teachers">
              <pl-select
                v-if="hasAdminAdminPermission && user.id !== getProfile.id"
                :id="'select_site_id_' + index"
                :options="school_sites"
                :selected="user.school_site"
                :isLoading="user.id === loadingUserSite"
                :disabled="user.id === loadingUserSite"
                @change="changeUserSchoolSite(user.id, $event)"
              >
              </pl-select>
              <span v-else class="ml3">{{ user.school_site }} </span>
            </td>
            <td class="col-xs-1">{{ user.rts_count }}</td>
            <td
              class="col-xs-1 no-padding"
              :class="{ 'col-xs-2': show_trial_teachers }"
            >
              {{ user.last_active }}
            </td>
            <template v-if="!show_trial_teachers">
              <td
                class="col-xs-1"
                v-if="hasAdminAdminPermission && user.id !== getProfile.id"
              >
                <pl-menu :menuSize="3" direction="right">
                  <pl-button slot="menu_trigger" class="pl-icon">
                    <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                  </pl-button>
                  <ul menu-content>
                    <li
                      @click="removeUserFromTable(user)"
                      style="color: #e53935"
                    >
                      Remove User
                      <i style="color: #e53935" class="fas fa-trash-alt" />
                    </li>
                  </ul>
                </pl-menu>
              </td>
            </template>
            <template v-else>
              <td class="col-xs-3">
                <button
                  class="upgrade-btn"
                  @click="upgradeTeacherAccount(user)"
                  v-if="user.role === 'teacher'"
                >
                  UPGRADE ACCOUNT
                </button>
              </td>
            </template>
          </tr>
        </tbody>
        <div
          v-else-if="usersToShow.length == 0"
          class="center-xs b no-users-style"
        >
          No Users.
        </div>
        <div
          class="flex center-xs middle-xs h-inherit"
          v-if="loadingTable"
          key="loading"
        >
          <pl-spinner />
        </div>
      </table>
      <dialog-delete-confirm
        v-if="show_remove_student_confirmation"
        @close="show_remove_student_confirmation = false"
        @actionConfirmed="removeUsersCallService"
        :subHeader="contentMessageToRemove"
        :optionalText="headerToRemoveUsers"
      />
      <dialog-delete-teachers-confirm
        v-if="show_remove_teachers_confirmation"
        @close="show_remove_teachers_confirmation = false"
        @actionConfirmed="removeUsersCallService"
        :subHeader="contentMessageToRemove"
        :optionalText="headerToRemoveUsers"
        :teachersToRemove="teachersToRemove"
      />
      <user-details-modal
        v-if="openDetailsUserID"
        @close="openDetailsUserID = ''"
        :userId="openDetailsUserID"
        :schoolSites="schoolSites"
        :userSchool="userSchool"
      />
    </template>
  </div>
</template>
<script>
  import userDetailsModal from 'features/admin/adminPortal/userDetailsModal/userDetailsModal';
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';
  import adminServices from 'services/admin/adminServices';
  import dialogDeleteConfirm from 'components/dialogDeleteConfirm';
  import dialogDeleteTeachersConfirm from 'components/dialogDeleteTeachersConfirm';

  export default {
    components: {
      dialogDeleteConfirm,
      userDetailsModal,
      dialogDeleteTeachersConfirm,
    },
    watch: {},
    data() {
      return {
        allSelected: false,
        selectedUsers: [],
        usersToBeRemoved: [],
        openDetailsUserID: '',
        show_remove_student_confirmation: false,
        show_remove_teachers_confirmation: false,
        show_trial_teachers: false,
        show_remove_confirmation: false,
        roles: ['teacher', 'student'],
        loadingUser: '',
        loadingTable: false,
        headerToRemoveUsers: 'Are you sure you want to delete this user',
        contentMessageToRemove:
          'This action will remove these users and their data from the organization. Deleted users can only be restored by adding them back to the organization.',
        teachersToRemove: [],
        loadingUserSite: '',
        totalSchoolUsers: 0,
        userSchool: '',
      };
    },
    props: {
      usersList: {
        type: Array,
        default: [],
      },
      trialTeachers: {
        type: Array,
        default: [],
      },
      loading: {
        type: Boolean,
        required: true,
      },
      schoolSites: {
        type: Array,
        default: [],
      },
      schoolUsersCount: {
        type: Number,
        default: 0,
      },
      schoolUsersCountLoaded: {
        type: Number,
        default: 0,
      },
    },
    computed: {
      ...mapGetters([
        'hasAdminAdminPermission',
        'getCurrentSchool',
        'getProfile',
      ]),
      usersToShow() {
        return this.show_trial_teachers ? this.trialTeachers : this.usersList;
      },
      school_sites() {
        return this.schoolSites.map((site) => site.name);
      },
    },
    methods: {
      openUserDetails(user) {
        this.openDetailsUserID = user.id;
        this.userSchool = user.school_id;
      },
      selectAll() {
        const all_s = this.allSelected;
        //school admin can't remove himself
        let users = this.usersToShow.filter((u) => u.id !== this.getProfile.id);
        users.forEach((itm) => (itm.selected = all_s));
        // in here I just need how many users are selected
        this.selectedUsers = users.filter((itm) => itm.selected);
      },
      checkAllSelected() {
        this.allSelected = this.usersToShow.every((itm) => itm.selected);
        // in here I just need how many users are selected
        this.selectedUsers = this.usersToShow.filter((itm) => itm.selected);
      },
      getTotalUsersSchool() {
        const schoolID = this.$route.params.schoolID;
        adminServices
          .getTotalSchoolUsersCount(schoolID)
          .then(({ data }) => (this.totalSchoolUsers = data));
      },
      async removeUserFromTable(user) {
        this.usersToBeRemoved = [user.id];
        this.headerToRemoveUsers =
          'Are you sure you want to delete this user ' + user.name;
        const teacherIDs = [user.id];
        const schoolID = this.$route.params.schoolID;
        await adminServices
          .getCoursesByTeacher(schoolID, teacherIDs)
          .then((teachers) => {
            this.teachersToRemove = teachers;
            this.teachersToRemove.forEach((teacher) => {
              teacher.courses.forEach((t) => {
                t.teachers.unshift({ id: '', name: 'Stay with teacher' });
              });
            });
          });
        if (user.role === 'teacher') {
          this.contentMessageToRemove =
            'This action will remove this teacher and data from the organization. Deleted users can only be restored by adding them back to the organization. You must also decide whether teacher courses will be removed from the school (they will stay with this teacher’s account) or reassigned to a different teacher.';
          this.show_remove_teachers_confirmation = true;
        } else {
          this.contentMessageToRemove =
            'This action will remove this user and data from the organization. Deleted users can only be restored by adding them back to the organization.';
          this.show_remove_student_confirmation = true;
        }
      },
      upgradeTeacherAccount(user) {
        const invite_code = this.getCurrentSchool.invites[0].code;
        const payload = {
          invite_code,
        };
        adminServices
          .upgradeTrialUser(this.$route.params.schoolID, user.id, payload)
          .then(() => {
            EventBus.$emit('upgraded-teacher', user);
            EventBus.$emit(
              'toast-msg',
              'Success! Teacher was upgraded to your school.'
            );
            this.getTotalUsersSchool();
          });
      },
      async removeSelectedUsers() {
        this.usersToBeRemoved = [
          ...this.selectedUsers.map((sel) => {
            return sel.id;
          }),
        ];

        const teachersSelected = this.selectedUsers.filter(
          (user) => user.role === 'teacher'
        );

        const teacherIDs = [
          ...teachersSelected.map((sel) => {
            return sel.id;
          }),
        ];

        const schoolID = this.$route.params.schoolID;
        await adminServices
          .getCoursesByTeacher(schoolID, teacherIDs)
          .then((teachers) => {
            this.teachersToRemove = teachers;
            this.teachersToRemove.forEach((teacher) => {
              teacher.courses.forEach((t) => {
                t.teachers.unshift({ id: '', name: 'Stay with teacher' });
              });
            });
          });
        this.headerToRemoveUsers =
          'Remove ' + this.usersToBeRemoved.length + ' Users';
        this.contentMessageToRemove =
          'This action will remove these users and their data from the organization. Deleted users can only be restored by adding them back to the organization.';
        if (this.teachersToRemove.length > 0) {
          this.contentMessageToRemove =
            'This action will remove ' +
            this.teachersToRemove.length +
            ' teacher(s) and their data from the organization. Deleted users can only be restored by adding them back to the organization. You must also decide whether teacher courses will be removed from the school (they will stay with this teacher’s account) or reassigned to a different teacher.';
          this.show_remove_teachers_confirmation = true;
        } else {
          this.show_remove_student_confirmation = true;
        }
      },
      // IT will remove the lis
      removeUsersCallService() {
        this.loadingTable = true;
        if (this.$route.params.schoolID && this.usersToBeRemoved.length > 0) {
          adminServices
            .removeUsersOfSchool(
              this.$route.params.schoolID,
              this.usersToBeRemoved
            )
            .then(() => {
              EventBus.$emit(
                'remove-users-of-school-from-table',
                this.usersToBeRemoved
              );
              this.totalSchoolUsers -= this.usersToBeRemoved.length;
              this.loadingTable = false;
              this.selectedUsers = [];
            })
            .then(() => {
              EventBus.$emit('updateUsersListAfterRemove');
              this.$store.dispatch(
                'getSchoolDetails',
                this.$route.params.schoolID
              );
            })
            .catch((error) => {
              this.loadingTable = false;
              if (
                error &&
                error.response &&
                error.response.data &&
                error.response.data.message
              ) {
                EventBus.$emit('toast-msg', error.response.data.message);
              } else {
                EventBus.$emit('toast-msg', error);
              }
              console.error(error);
            });
        } else {
          EventBus.$emit('toast-msg', 'Something went wrong! Contact support.');
        }
      },
      changeUserRole(id, role) {
        if (role && this.usersList.find((u) => u.id === id).role !== role) {
          this.loadingUser = id;
          const payload = { role: role };
          adminServices
            .updateUserRole(this.$route.params.schoolID, id, payload)
            .then(() => {
              EventBus.$emit('toast-msg', 'User Role changed to ' + role + '.');
              this.usersList.map((u) => {
                if (u.id === id) {
                  return (u.role = role);
                }
              });
              this.loadingUser = '';
            })
            .catch((error) => {
              EventBus.$emit('toast-msg', error.response.data.message);
              this.loadingUser = '';
              console.error(error);
            });
        }
      },
      changeUserSchoolSite(id, site) {
        const user = this.usersList.find((u) => u.id === id);
        const site_object = this.schoolSites.find((s) => s.name === site);
        if (site && user.school_site !== site) {
          this.loadingUserSite = id;
          const payload = {
            site_id: site_object.id,
            site: site_object.name,
          };
          this.$store
            .dispatch('updateUserSchoolSite', {
              schoolID: this.$route.params.schoolID,
              userID: user.id,
              payload: payload,
            })
            .then(() => {
              EventBus.$emit('toast-msg', 'User School Site updated');
              this.usersList.map((u) => {
                if (u.id === id) {
                  return (u.school_site = site);
                }
              });
              this.loadingUserSite = '';
            })
            .catch((error) => {
              EventBus.$emit('toast-msg', error.response.data.message);
              this.loadingUserSite = '';
              console.error(error);
            });
        }
      },
      cleanUsersTableEvent() {
        EventBus.$on('admin-portal-filter-changed', () => {
          this.usersToShow.map((itm) => {
            return (itm.selected = false);
          });
          this.usersToBeRemoved = [];
          this.allSelected = false;
          this.selectedUsers = [];
        });
      },
    },
    created() {},
    mounted() {
      this.getTotalUsersSchool();
      this.cleanUsersTableEvent();
      EventBus.$on('show_trial_teachers', () => {
        this.show_trial_teachers = !this.show_trial_teachers;
      });
      EventBus.$on('update-user-email-users-table', (value) => {
        const user = this.usersList.find((u) => u.id === value.id);
        if (user) {
          user.email = value.email;
        }
      });
    },
    beforeDestroy() {
      EventBus.$off('admin-portal-filter-changed');
      EventBus.$off('show_trial_teachers');
    },
  };
</script>

<style lang="stylus" scoped>
  @import '~app/global-stylus.styl';

  .upgrade-btn
    color:#5FA95C
    border: 2px solid #5FA95C
    padding:10px
    cursor:pointer
  .users-table
    padding 0
    tbody
      display:block;
      overflow-y: auto;
      overflow-x:hidden;
      height: calc(100vh - 340px);
      &:not(.trial_teacher_table)
        height: calc(100vh - 300px);
      padding: 10px 8px;
      tr
        border: 2px solid #e6e7e7
        border-bottom: none;
        align-items: center
        &:last-child
          border-bottom: 2px solid #e6e7e7
    td
      padding 1rem
      &.pending
        color: pl-ruby
      &.name-cell
        color: #78BEC8
        text-decoration: underline
      &.email-cell
        overflow: hidden
        text-overflow: ellipsis
        white-space: nowrap
    thead tr
      padding: 0 10px;
      td
        padding: 0 1rem

  .no-users-style
    padding-top: 20px;

  .remove-selected-users{
    margin: 6px 0px;
  }

  .name-cell
    color: #78BEC8
    text-decoration: underline

  .avatar-size
    min-width: 40px
    min-height: 40px
    max-width: 40px
    max-height: 40px
</style>



// WEBPACK FOOTER //
// adminPortalUsersTable.vue?8e2854ae